module.exports = __webpack_public_path__ + "static/media/3.a633df4e.jpeg";